// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 267) return "static/css/267.e4ea568624c51e8b2e93.lib.css";
	if (chunkId === 264) return "static/css/264.ddbe1a3300306f4ce4d7.css";
	// return url for filenames based on template
	return undefined;
};